import { Icon } from '@fattureincloud/fic-design-system'
import { faTimes } from '@fortawesome/pro-light-svg-icons'
import React, { FC, useEffect, useState } from 'react'

import logoFb from '../../assets/img/logo-fb-circle.png'
import { Button } from '../../layout_components/Button'
import { locale } from '../../locales/locale'
import { FBCommunityBannerContainer } from './header.components'

const FBCommunityBanner: FC = () => {
  const [isFacebookBannerVisible, setFacebookBannerVisible] =
    useState<boolean>(false)

  useEffect(() => {
    setFacebookBannerVisible(
      !localStorage.getItem('helpFacebookBannerIsVisible')
    )
  }, [])

  const goToFBPage = () => {
    window.open('https://bit.ly/fic-fb', '_blank')
    hideFacebookBanner()
  }

  const hideFacebookBanner = () => {
    localStorage.setItem('helpFacebookBannerIsVisible', 'false')
    setFacebookBannerVisible(false)
  }

  return (
    <FBCommunityBannerContainer
      isVisible={isFacebookBannerVisible}
    >
      <div>
        <img src={logoFb} alt={'facebook-logo'} />
        <span>
          {locale('Migliaia di utenti utilizzano la nostra community su Facebook per aiutarsi tra di loro e per ricevere supporto.')}
          <Button
            type={'facebook'}
            target={'_blank'}
            onClick={() => goToFBPage()}
            text={locale('Iscriviti anche te!')}
            style={{ marginLeft: 5 }}
          />
        </span>
        <Icon icon={faTimes} onClick={hideFacebookBanner} />
      </div>
    </FBCommunityBannerContainer>
  )
}

export default FBCommunityBanner
